const configProviderContextKey = Symbol();
export { configProviderContextKey };